import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { EmailRulesServiceProvider } from '../../api/email-rules'

const EmailRulesService = EmailRulesServiceProvider()
const storeName = 'createEmailRule'

export default ({ name, queryParameters }) => (asyncAction(
  storeName,
  EmailRulesService.createEmailRule,
  { name: name, queryParameters }
))

export const reducer = asyncReducer(storeName)
export const selector = asyncSelector(storeName)



// WEBPACK FOOTER //
// ./src/store/email-rules/createEmailRule.js